import React, { Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";

// Lazy load components below the fold
const ServicesSection = React.lazy(() => import("@/components/ServicesSection"));
const BookingForm = React.lazy(() => import("@/components/BookingForm"));
const GallerySection = React.lazy(() => import("@/components/GallerySection"));
const WhyUsSection = React.lazy(() => import("@/components/WhyUsSection"));
const Footer = React.lazy(() => import("@/components/Footer"));
const WhatsAppFloat = React.lazy(() => import("@/components/WhatsAppFloat"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <Navbar />
      <HeroSection />
      
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <ServicesSection />
        <BookingForm />
        <GallerySection />
        <WhyUsSection />
        <Footer />
        <WhatsAppFloat />
      </Suspense>
    </div>
  );
};

export default Index;
